{
	"title": "Голосовой репетитор",
	"subtitle": "Голосовой режим",
	"intro": {
		"title": "Чем голосовой репетитор отличается",
		"body": "Это разговор: вы говорите вслух, вас слушают и отвечают. Репетитор в чате отвечает текстом, аудио-резюме просто озвучивает материал.",
		"bullets": [
			"Разговор в обе стороны — в отличие от аудио-резюме",
			"Голосом, а не текстом — в отличие от чата",
			"Идёт по плану урока или точечно по одному пробелу"
		]
	},
	"lessonPlan": {
		"title": "План урока",
		"topics": "Темы",
		"generating": "Готовим план урока…"
	},
	"session": {
		"ready": "Готов к занятию",
		"starting": "Начинаем…",
		"active": "Идёт занятие",
		"paused": "Пауза",
		"ending": "Завершаем…",
		"ended": "Занятие завершено",
		"duration": "Длительность: {time}"
	},
	"actions": {
		"start": "Начать занятие",
		"pause": "Пауза",
		"resume": "Продолжить",
		"end": "Завершить",
		"interrupt": "Перебить"
	},
	"error": {
		"startFailed": "Не удалось начать занятие. Попробуй ещё раз.",
		"endFailed": "Не удалось корректно завершить сессию.",
		"planNotReady": "Сначала дождись готового плана урока"
	},
	"indicators": {
		"listening": "Слушаю",
		"thinking": "Думаю",
		"speaking": "Говорю",
		"audioOff": "Звук выключен"
	},
	"settings": {
		"voice": "Голос",
		"speed": "Темп речи",
		"language": "Язык занятия",
		"topic": "Тематика, предмет или пожелания по уроку",
		"duration": "Длительность сессии",
		"tutorVoice": "Голос репетитора",
		"speechSpeed": "Темп речи · {speed}×",
		"saveTranscript": "Сохранить <0>текст реплик</0> (НЕ аудио) после сессии",
		"saveTranscriptHint": "Текст поможет вернуться к ключевым моментам. Аудио всё равно не записывается.",
		"generateLessonPlan": "Сгенерировать план урока",
		"lessonPlanTitle": "План урока · 4 шага",
		"lessonPlanAiBadge": "План сгенерирован AI. Можно поправить голосом во время сессии."
	},
	"mic": {
		"aria": {
			"idle": "Включить голосовой режим",
			"connecting": "Подключение",
			"listening": "Микрофон активен — выключить",
			"muted": "Микрофон выключен — включить",
			"error": "Ошибка соединения — переподключиться"
		}
	},
	"conn": {
		"connecting": "Подключение",
		"connected": "В эфире",
		"networkDrop": "Связь нестабильна",
		"paused": "Пауза",
		"ended": "Завершено"
	},
	"transcript": {
		"title": "Транскрипт диалога",
		"empty": "Реплики появятся здесь, когда занятие начнётся.",
		"speakerUser": "Я",
		"speakerTutor": "Репетитор"
	},
	"recentSessions": {
		"title": "Недавние сессии",
		"empty": "Здесь появятся твои прошлые голосовые занятия."
	},
	"plan": {
		"step1": "Введение: ключевые понятия темы",
		"step2": "Глубокое объяснение через примеры",
		"step3": "Проверка понимания: вопросы от AI",
		"step4": "Резюме и контрольные вопросы"
	},
	"compliance": {
		"audioNotStored": "Аудио не сохраняется на сервере",
		"transcriptOnly": "Сохраняется только текст диалога",
		"audioNotStoredShort": "Аудио не сохраняется"
	},
	"disclaimer": {
		"title": "Перед началом голосовой сессии",
		"body": "Голосовая сессия использует AI. Ваша речь обрабатывается в реальном времени и **не сохраняется** на наших серверах. AI может ошибаться — проверяйте важные факты.",
		"checkbox": "Понимаю: речь обрабатывается AI в реальном времени и не сохраняется",
		"confirm": "Начать сессию",
		"cancel": "Отмена"
	},
	"consent": {
		"title": "Перед запуском голосовой сессии",
		"body": "Голосовая сессия использует AI. Речь обрабатывается в реальном времени; аудио не сохраняется ни нами, ни AI-сервисом.",
		"required": "Я согласен(а) на обработку моей речи AI-сервисом.",
		"saveTranscript": "Сохранить текстовую стенограмму урока (опционально)",
		"start": "Начать сессию",
		"cancel": "Отмена",
		"requireAgree": "Для начала сессии нужно подтвердить согласие выше."
	},
	"live": {
		"fatal": {
			"expiredTitle": "Сессия недоступна",
			"failedTitle": "Сессия завершена с ошибкой",
			"expiredBody": "Голосовую сессию нельзя возобновить (токен истёк или сессия закрыта). Начни новое занятие.",
			"failedBody": "Соединение с AI прервалось. Попробуй начать занятие заново.",
			"back": "К настройке занятия"
		},
		"header": {
			"end": "Завершить",
			"endAria": "Завершить сессию"
		},
		"mobilePlan": {
			"trigger": "План {done}/{total}",
			"triggerEmpty": "План урока",
			"title": "План урока",
			"openAria": "Открыть план урока",
			"empty": "Готовим план урока — обычно ~10 секунд."
		},
		"controls": {
			"mic": "Микрофон",
			"mute": "Заглушить",
			"unmute": "Включить микрофон",
			"reconnect": "Переподключиться",
			"micOff": "Выключить микрофон",
			"micOn": "Включить микрофон",
			"speakerOff": "Выключить звук",
			"speakerOn": "Включить звук"
		},
		"states": {
			"connecting": "Подключаемся к репетитору и микрофону…",
			"errorBody": "Не удалось подключиться к репетитору. Проверь доступ к микрофону и работает ли сервер.",
			"reconnect": "Переподключиться",
			"closed": "Соединение с репетитором закрыто (сервер недоступен или сессия завершилась).",
			"backToSetup": "Вернуться к настройке",
			"connected": "Говори в микрофон — репетитор слушает и отвечает. Можно перебивать в любой момент.",
			"muted": "Микрофон выкл.",
			"preparing": "Готовим занятие…"
		},
		"toast": {
			"micDenied": "Нет доступа к микрофону. Разреши доступ и попробуй снова.",
			"timeUp": "Время сессии истекло — завершаем занятие.",
			"sessionEnded": "Сессия завершена — транскрипт сохранён."
		},
		"defaultTopic": "Голосовое занятие",
		"yourTurn": "Твоя очередь — ответь голосом",
		"tutorSpeaking": "репетитор отвечает — можно перебить",
		"focusMode": "Фокус",
		"showTranscript": "Показать транскрипт",
		"currentStep": "Сейчас",
		"quickReply": {
			"understood": "Понятно",
			"explainAgain": "Поясни ещё раз",
			"next": "Дальше"
		},
		"quickReplyLabel": "Быстрый ответ",
		"toolStatus": {
			"searching": "Поиск материалов…",
			"visual": "Подготовка диаграммы…",
			"working": "Выполняется…"
		},
		"visual": {
			"dismiss": "Закрыть диаграмму"
		},
		"jumpInstruction": "[Управление уроком] Студент выбрал в плане раздел «{title}». Плавно переключись на этот раздел: коротко обозначь переход и продолжай объяснение именно по нему. Отвечай на том же языке, на котором идёт занятие.",
		"jumpToast": "Переходим к разделу «{title}»"
	},
	"history": {
		"backAria": "Назад",
		"back": "Назад",
		"statusFailed": "Прервана",
		"statusEnded": "Завершена",
		"transcriptCaption": "Транскрипт прошедшей сессии",
		"transcriptEmpty": "Транскрипт не сохранён. Возможно, сессия была завершена слишком рано или сохранение текста было выключено.",
		"speakerUser": "Я",
		"speakerTutor": "Репетитор",
		"lessonPlanHeading": "План урока",
		"resume": "Возобновить",
		"resumeConfirmTitle": "Сессия завершена",
		"resumeConfirmBody": "Эта голосовая сессия уже завершена. Возобновить её и продолжить разговор с того места, где остановились?"
	},
	"endConfirm": {
		"title": "Завершить занятие?",
		"descriptionWithTime": "Сессия длится <0>{minutes} мин</0>. Прогресс по плану сохранится.",
		"description": "Прогресс по плану сохранится.",
		"continue": "Продолжить занятие",
		"end": "Завершить"
	},
	"plannerSidebar": {
		"title": "План урока",
		"progressLabel": "Пройдено шагов",
		"collapseAria": "Свернуть",
		"expandAria": "Развернуть",
		"empty": "Готовим план урока — обычно ~10 секунд.",
		"jumpHint": "Перейти к этому разделу"
	},
	"wizard": {
		"title": "Новое голосовое занятие",
		"step.source": "Источник",
		"step.plan": "План",
		"step.voice": "Голос",
		"step1Hint": "Выбери материал или загрузи новый — на его основе AI построит план урока.",
		"step2Hint": "Выбери уровень и длительность — и сгенерируй план урока перед стартом.",
		"step3Hint": "Выбери язык и голос репетитора. Можно прослушать перед запуском.",
		"selectMaterials": "Выбрать материалы",
		"materialsSelected": "{count, plural, one {# материал выбран} few {# материала выбрано} many {# материалов выбрано} other {# материалов выбрано}}",
		"collectionSelected": "Папка: {name}",
		"orTopic": "или задай тему без материалов",
		"regeneratePlan": "Перегенерировать план",
		"back": "Назад",
		"next": "Дальше",
		"cancel": "Отмена",
		"level": {
			"title": "Уровень",
			"hint": "От уровня зависит глубина занятия, от возраста — язык и тон репетитора. Можно не выбирать."
		}
	},
	"idle": {
		"tagline": "Говори с AI вслух — он знает твой материал и держит план урока.",
		"topicPlaceholder": "Цикл Кребса, фотосинтез, теория множеств…",
		"materialLabel": "Материал",
		"materialNone": "Без материала",
		"materialSearch": "Найти материал…",
		"materialHint": "AI будет привязан к фрагментам выбранного материала и цитировать конкретные места.",
		"durationMinutes": "{count, plural, one {# минута} few {# минуты} other {# минут}}",
		"planGenerating": "AI составляет план урока…",
		"planFailed": "Не удалось сгенерировать план",
		"planRetry": "Повторить",
		"planReady": "План урока · {count, plural, one {# шаг} few {# шага} other {# шагов}}",
		"quotaExhausted": "Минуты голосового репетитора закончились. Обнови тариф.",
		"lockedCta": "Доступно на Plus / Pro",
		"lockedHint": "На Free голосовой репетитор недоступен. Plus / Pro — до 120 мин/мес.",
		"planRequiredCta": "Сначала сгенерируй план урока",
		"lockedCtaNoSale": "Пока недоступно",
		"lockedHintNoSale": "Голосовой тьютор пока недоступен в этом приложении.",
		"quotaExhaustedNoSale": "Минуты голосового репетитора пока закончились."
	},
	"voices": {
		"Aoede": "Тёплый, дружелюбный",
		"Charon": "Спокойный, академический",
		"Kore": "Уверенный, чёткий",
		"Puck": "Энергичный, живой",
		"Fenrir": "Глубокий, выразительный",
		"Zephyr": "Светлый, лёгкий",
		"Leda": "Юный, чистый",
		"Orus": "Твёрдый, уверенный",
		"Callirrhoe": "Расслабленный, размеренный",
		"Autonoe": "Дружелюбный, открытый",
		"Enceladus": "Мягкий, неторопливый",
		"Iapetus": "Низкий, медитативный",
		"Umbriel": "Тёмный, спокойный",
		"Algieba": "Бархатный, повествовательный",
		"Despina": "Мелодичный, плавный",
		"Erinome": "Сдержанный, профессиональный",
		"Algenib": "Сильный, эмоциональный",
		"Rasalgethi": "Ровный, объективный",
		"Laomedeia": "Игривый, лёгкий",
		"Achernar": "Звонкий, ясный",
		"Alnilam": "Уравновешенный, нейтральный",
		"Schedar": "Чёткий, наставнический",
		"Gacrux": "Глубокий, доверительный",
		"Pulcherrima": "Изящный, выразительный",
		"Achird": "Мягкий, сочувствующий",
		"Zubenelgenubi": "Живой, разговорный",
		"Vindemiatrix": "Аналитический, точный",
		"Sadachbia": "Светлый, оптимистичный",
		"Sadaltager": "Знающий, авторитетный",
		"Sulafat": "Спокойный, утончённый"
	},
	"voicePicker": {
		"preview": "Прослушать голос",
		"stop": "Остановить",
		"placeholder": "Выбери голос"
	},
	"list": {
		"subtitle": "{count, plural, one {# голосовая сессия} few {# голосовые сессии} many {# голосовых сессий} other {# голосовых сессий}}",
		"newSession": "Новая сессия",
		"continue": "Продолжить",
		"searchPlaceholder": "Поиск по сессиям…",
		"errorTitle": "Не удалось загрузить сессии",
		"retry": "Повторить",
		"emptyDescription": "Начни голосовую сессию — репетитор знает твой материал.",
		"backToList": "К сессиям",
		"stageProgress": "Этап {stage} из {total}"
	}
}
